<template>
  <v-layout justify-center>
    <v-flex xs12 sm8 md4>
      <panel title="eTickets">
        <v-form slot="body">
          <h3>Testing</h3>
        </v-form>
        <div slot="actions">
          Actions
        </div>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
// import Pusher from 'pusher-js'
import Panel from '@/components/Panel'

export default {
  components: {
    Panel
  },
  created () {
    // this.realtimeTicket()
  },
  mounted () {
    console.log(process.env.API_URL)
  },
  methods: {
    // realtimeTicket () {
    //   let pusher = new Pusher('2661075de5b720395ae9', { cluster: 'us2' })
    //   pusher.subscribe('eTicket')
    //   pusher.bind('ticket', data => {
    //     console.log(data.message)
    //   })
    // }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Ticket.vue